import announcer from './aria-announcer';

window.addEventListener('DOMContentLoaded', () => {
    const legendButton = document.querySelector('.legend');
    const dropdown = document.querySelector('.dropdown-legend');

    if (!legendButton || !dropdown) return;

    legendButton.setAttribute('aria-expanded', 'false');

    legendButton.addEventListener('click', () => {
        const isExpanded = legendButton.getAttribute('aria-expanded') === 'true';
        const newState = !isExpanded;

        legendButton.setAttribute('aria-expanded', String(newState));
        legendButton.classList.toggle('is-open', newState);
        dropdown.classList.toggle('is-open', newState);

        if (newState) {
            announcer.announce('La légende est ouverte');
        } else {
            announcer.announce('La légende est fermée');
        }
    });

    legendButton.addEventListener('blur', () => {
        legendButton.setAttribute('aria-expanded', 'false');
        legendButton.classList.remove('is-open');
        dropdown.classList.remove('is-open');
        announcer.announce('La légende est fermée');
    });
});
